import { FormEvent, FormEventHandler } from 'react';
import styles from './BaseForm.module.scss';

interface BaseFormProps {
  formId: string;
  onChange?: FormEventHandler<unknown>;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
}

export const BaseForm = ({
  formId,
  onChange = () => void 0,
  onSubmit,
  children
}: BaseFormProps) =>
  <form
    id={formId}
    className={styles.baseForm}
    onChange={onChange}
    data-aos="fade-up"
    onSubmit={onSubmit}
  >
    <fieldset>
      {children}
    </fieldset>
  </form>
;
